export function arrayValidation(array: any): boolean {
  return array && Array.isArray(array) && array.length;
}
